import * as React from 'react';
import { PageWrap } from '../layouts';
import { H1, H3 } from '../typography';
import Button from './Button';
import { theme } from '../theme';

type ErrorFallbackProps = {};

const ErrorFallback: React.FC<ErrorFallbackProps> = props => {
  return (
    <PageWrap
      data-testid="error-fallback"
      height="100vh"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
    >
      <H1 mb={4} color="putty">
        Oops, an error has occurred!
      </H1>
      <H3>It has been reported and will be attended to, please refresh your browser.</H3>
      <Button
        my={4}
        bg={theme.colors.putty}
        width="200px"
        type="button"
        color="white"
        text="Go Home"
        onClick={() => (window.location.href = '/')}
      />
    </PageWrap>
  );
};

export default ErrorFallback;



// WEBPACK FOOTER //
// ./src/components/ErrorFallback.tsx